import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { THEME } from 'src/enums/theme';
import CloseIcon from 'src/icons/close.svg';

import styles from './CloseButton.module.scss';

interface CloseButtonProps {
  ariaLabel: string;
  onClick: () => void;
  theme?: THEME;
}

export const CloseButton: FunctionComponent<CloseButtonProps> = ({ ariaLabel, onClick, theme = THEME.LIGHT }) => (
  <button
    className={classNames(styles.closeButton, styles[theme])}
    type="button"
    aria-label={ariaLabel}
    onClick={onClick}
  >
    <CloseIcon className={styles.closeIcon} role="img" />
  </button>
);
